export default "__VITE_ASSET__B9Xb4tLA__"